<template>
  <span class="linkWrapper" :class="[{ linkText: !hasUrl }, arrowIfNotLink, { isSp: isSp }]" @click="onClick($event)">
    <a v-if="hasUrl" :href="linkUrl" :target="targetValue" :class="arrowType" class="linkText">
      {{ linkText }}
    </a>
    <template v-else>
      {{ linkText }}
    </template>
  </span>
</template>

<script>
export default {
  name: 'TextLink',
  props: {
    linkUrl: {
      type: String,
      required: false,
      default: undefined,
    },
    linkText: {
      type: String,
      required: true,
    },
    targetValue: {
      required: false,
      default: '_self',
      validator(value) {
        return ['_self', '_blank', '_parent', '_top'].indexOf(value) !== -1;
      },
    },
    arrowType: {
      required: false,
      default: undefined,
      validator(value) {
        return ['rightArrowRight', 'leftArrowLeft', 'leftArrowLeftBold'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    hasUrl() {
      return Boolean(this.linkUrl);
    },
    arrowIfNotLink() {
      if (!this.hasUrl) return this.arrowType;

      return '';
    },
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
  methods: {
    onClick(event) {
      this.$emit('onClick', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.linkWrapper {
  display: inline-block;
}

.linkText {
  color: $color-text-link;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  // SPのactiveのときに発火してしまうのでSPではnoneを設定
  &.isSp:hover {
    text-decoration: none;
  }
}

.rightArrowRight {
  position: relative;
  margin-right: 12px;

  &::after {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    border-bottom: solid 1px $color-text-link;
    border-right: solid 1px $color-text-link;
    transform: rotate(-45deg);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: -10px;
  }
}

.leftArrowLeft {
  position: relative;
  margin-left: 8px;

  &::before {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    border-bottom: solid 1px $color-text-link;
    border-right: solid 1px $color-text-link;
    transform: rotate(135deg);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: -10px;
  }
}

.leftArrowLeftBold {
  position: relative;
  margin-left: 8px;

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-bottom: solid 2px $color-text-link;
    border-right: solid 2px $color-text-link;
    transform: rotate(135deg);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: -16px;
  }
}
</style>
